import { render, staticRenderFns } from "./NoteItem.vue?vue&type=template&id=05995964&scoped=true"
import script from "./NoteItem.vue?vue&type=script&lang=js"
export * from "./NoteItem.vue?vue&type=script&lang=js"
import style0 from "./NoteItem.vue?vue&type=style&index=0&id=05995964&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05995964",
  null
  
)

export default component.exports